import { ProductVariantEffects } from './product-variant.effects';
export const effects: any[] = [ProductVariantEffects];
